<template>

    <div class="container_page">
        <div class="lang-radio-wrap">
            <a-radio-group v-model="filterData.lang" button-style="solid" @change="changeTabTop">
                <a-radio-button value="CH">中文版</a-radio-button>
                <a-radio-button value="EN">英文版</a-radio-button>
            </a-radio-group>
        </div>
        <a-form layout="inline">
            <a-form-item label="搜索关键字">
                <a-input placeholder="请输入搜索关键字" v-model="filterData.keywords"/>
            </a-form-item>
            <a-form-item label="发布状态">
                <a-select style="width: 200px" v-model="filterData.status" class="mr12" placeholder="请选择发布状态"
                          show-search option-filter-prop="name" :filter-option="filterOption">
                    <a-select-option v-for="(item, index) of list" :key="index" :value="item.value">
                        {{ item.lable }}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item>
                <a-button class="mr12" type="primary" @click="toSearch(true)">查询</a-button>
                <a-button class="mr12" @click="toSearch(false)">重置</a-button>
                <a-button @click="toAdd" type="primary" class="mr12" v-if="filterData.lang === 'CH'">添加搜索词</a-button>
            </a-form-item>
        </a-form>

        <a-row style="margin-top: 16px;margin-bottom: 16px;" :gutter="20" justify="start">
            <a-col :xs="24" :sm="24" :md="8">
                <div class="stat-card">
                    <div class="stat-header">
                        <div>
                            <span class="stat-t1">总搜索词</span>
                            <span class="stat-t2">{{factoryNum+brandNum}}</span>
                        </div>
                        <a-icon type="search"/>
                    </div>
                    <div class="stat-bot">
                        <div class="t1">工厂：{{factoryNum}}</div>
                        <div class="t2">品牌：{{brandNum}}</div>
                    </div>
                </div>
            </a-col>
            <a-col :xs="24" :sm="24" :md="8">
                <div class="stat-card">
                    <div class="stat-header">
                        <div>
                            <span class="stat-t1">已启用</span>
                            <span class="stat-t2">{{factoryEnableNum+brandEnableNum}}</span>
                        </div>
                        <a-icon type="search"/>
                    </div>
                    <div class="stat-bot">
                        <div class="t1">工厂：{{factoryEnableNum}}</div>
                        <div class="t2">品牌：{{brandEnableNum}}</div>
                    </div>
                </div>
            </a-col>
            <a-col :xs="24" :sm="24" :md="8">
                <div class="stat-card">
                    <div class="stat-header">
                        <div>
                            <span class="stat-t1">今日搜索量</span>
                            <span class="stat-t2">{{factoryTodaySearchCount+brandTodaySearchCount}}</span>
                        </div>
                        <a-icon type="search"/>
                    </div>
                    <div class="stat-bot">
                        <div class="t1">工厂：{{factoryTodaySearchCount}}</div>
                        <div class="t2">品牌：{{brandTodaySearchCount}}</div>
                    </div>
                </div>
            </a-col>
        </a-row>
        <a-radio-group style="margin-bottom: 16px;" v-model="filterData.searchCategory" button-style="solid"
                       @change="changeTabTop">
            <a-radio-button style="width: 150px;text-align: center;" value="FACTORY">工厂</a-radio-button>
            <a-radio-button style="width: 150px;text-align: center;" value="BRAND">品牌</a-radio-button>
        </a-radio-group>

        <a-table :columns="columns" :data-source="tableData" :pagination="pageInfo" @change="changePage"
                 :loading="loading">
            <!-- 搜索分类 -->
            <template slot="searchCategoryRender" slot-scope="text, record">
                <div>
                    <span>{{record.searchCategory=='FACTORY'?'工厂':record.searchCategory=='BRAND'?'品牌':''}}</span>
                </div>
            </template>
            <template slot="statusRender" slot-scope="text, record">
                <div style="display: flex;align-items: center;">
                    <a-switch :checked="!!record.status" @change="(checked) => handlePublishChange(checked, record)"/>
                    <a-tag style="margin-left: 10px;" color="#2db7f5" v-if="record.status === true">
                        启用
                    </a-tag>
                    <a-tag style="margin-left: 10px;" v-else-if="record.status === false">
                        禁用
                    </a-tag>
                    <a-tag style="margin-left: 10px;" v-else></a-tag>
                </div>
            </template>
            <template slot="indexSortender" slot-scope="text, record">
                <a-input v-model.number="record.sort" placeholder="排序" type="number" @blur="handleSaveSort(record)"
                         @keyup.enter="handleSaveSort(record)"/>
            </template>
            <template slot="action" slot-scope="text, record">
                <div class="flex_center">
                    <span><a-button type="link" @click="toEdit(record)">编辑</a-button></span>
                <a-popconfirm v-if="filterData.lang === 'CH'" title="你确定删除这条信息吗？" okText="确定" cancelText="取消" @confirm="sureDelete(record)">
                        <a-button type="link">删除</a-button>
                    </a-popconfirm>
                </div>
            </template>
        </a-table>
        <a-modal :visible="imgModel.flag" width="880px" :closable="false" maskClosable :destroyOnClose="true">
            <template slot="footer">
                <a-button @click="imgModel.flag = false">关闭</a-button>
            </template>
            <span>
				<img :src="imgModel.url" alt="" style="width: 800px;height: 296px"/>
			</span>
        </a-modal>
        <a-modal :title="tipsModel.title" :visible="tipsModel.flag" @ok="tipsModel.onOk"
                 @cancel="tipsModel.flag = false">
			<span>
				{{ tipsModel.content }}
			</span>
        </a-modal>
        <a-modal :title="editModel.title" :visible="editModel.flag" width="800px" @ok="editModel.onOk"
                 @cancel="editModel.flag = false">
            <a-form-model :model="editModel" :label-col="labelCol" :wrapper-col="wrapperCol" ref="editForm"
                          :rules="editRules">
                <a-row>
                    <a-col :span="24">
                        <a-form-model-item label="搜索分类" prop="searchCategory" required>
                            <a-radio-group name="radioGroup" v-model="editModel.searchCategory">
                                <a-radio value="FACTORY"> 工厂</a-radio>
                                <a-radio value="BRAND"> 品牌</a-radio>
                            </a-radio-group>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="24">
                        <a-form-model-item label="关键词" prop="keyword" required>
                            <a-input style="width: 180px;" placeholder="请输入搜索关键词" v-model="editModel.keyword"/>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="24">
                        <a-form-model-item v-if="editModel.searchCategory=='FACTORY'" label="关联工厂"
                                           prop="factoryAssociatedId">
                            <a-select style="width: 200px" v-model="editModel.factoryAssociatedId" class="mr12"
                                      placeholder="请选择工厂" show-search option-filter-prop="name"
                                      :filter-option="filterOption">
                                <a-select-option v-for="(item, index) of factoryList" :key="index"
                                                 :value="item.businessId">
                                    {{ item.businessName }}
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                        <a-form-model-item v-if="editModel.searchCategory=='BRAND'" label="关联品牌"
                                           prop="brandAssociatedId">
                            <a-select style="width: 200px" v-model="editModel.brandAssociatedId" class="mr12"
                                      placeholder="请选择品牌" show-search option-filter-prop="name"
                                      :filter-option="filterOption">
                                <a-select-option v-for="(item, index) of brandList" :key="index"
                                                 :value="item.businessId">
                                    {{ item.businessName }}
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="24">
                        <a-form-model-item label="启用状态" prop="status">
                            <a-switch :checked="editModel.status" @change="statusChange"/>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="24">
                        <a-form-model-item label="排序" prop="sort">
                            <a-input style="width: 180px;" placeholder="显示排序" v-model.number="editModel.sort" type="number" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
        </a-modal>
    </div>
</template>

<script>
    import {
        getHotWordsListApi, //列表
        getHotWordsDetailApi, //详情  不知道从哪里点进去详情
        saveHotWordsApi, //编辑
        deleteHotWordsApi, //删除
        updateHotWordsSortApi, //
        updateHotWordsStatusApi,
        getBusinessEntitiesApi,
        // getOssAuth,

    } from "../../api/index";

    export default {
        name: "cardsList",
        data() {
            return {
                activeTab: 'FACTORY',
                commodityStatusList: [{
                    label: "开启",
                    value: true,
                },
                    {
                        label: "关闭",
                        value: false,
                    },
                ],
                columns: [{
                    title: '序号',
                    dataIndex: 'index',
                    key: 'index',
                    customRender: (text, record, index) => {
                        return (this.pageInfo.current - 1) * this.pageInfo.pageSize + index + 1
                    }
                },
                    {
                        title: '搜索分类',
                        dataIndex: 'searchCategory',
                        key: 'searchCategory',
                        scopedSlots: {
                            customRender: "searchCategoryRender"
                        },
                    },
                    {
                        title: '搜索关键词',
                        dataIndex: 'keyword',
                        key: 'keyword',

                    },
                    {
                        title: '搜索次数',
                        dataIndex: 'searchCount',
                        key: 'searchCount',
                    },
                    {
                        title: '发布状态',
                        dataIndex: 'status',
                        key: 'status',
                        scopedSlots: {
                            customRender: "statusRender"
                        },
                    },
                    {
                        title: '排序',
                        dataIndex: 'sort',
                        key: 'sort',
                        scopedSlots: {
                            customRender: "indexSortender"
                        },
                    },
                    {
                        title: '操作',
                        key: 'action',
                        scopedSlots: {
                            customRender: 'action'
                        },
                    }
                ],
                tableData: [],
                pageInfo: {
                    pageSize: 10,
                    current: 1,
                    total: 0,
                    showTotal: (total, range) => {
                        return `合计 ${total} 条记录`;
                    },
                },
                loading: false,
                imgModel: {
                    flag: false,
                    url: "",
                },
                tipsModel: {
                    flag: false,
                    title: "",
                    content: "",
                    giftCardId: 0,
                    giftCardStatus: undefined,
                    onOk: () => {
                    },
                },
                editModel: {
                    flag: false,
                    title: "新建其他标签信息",
                    "businessId": 0, //工厂名称ID/品牌Id
                    "businessLogo": "", //LOGO
                    "businessName": "", //工厂名称/品牌名称
                    "businessEnName": "", //工厂名称/品牌名称  英文
                    "businessType": "", //类型    FACTORY 工厂 、BRABD 品牌 、SUPPLIER 供应商
                    onOk: () => {
                    },
                },
                formState: {
                    "iconUrl": "", //卡片图标
                    "name": "", //卡片名称
                    "sort": 1 //序号
                },
                labelCol: {
                    span: 4
                },
                wrapperCol: {
                    span: 18
                },
                filterData: {
                    keywords: "",
                    status: undefined,
                    lang: 'CH',
                    searchCategory: "FACTORY",
                },
                list: [{
                    value: true,
                    lable: "启用"
                },
                    {
                        value: false,
                        lable: "禁用"
                    }
                ],
                factoryNum: 0, //总搜索词  工厂
                brandNum: 0, //总搜索词  品牌
                factoryEnableNum: 0, //已启用 工厂
                brandEnableNum: 0, //已启用  品牌
                factoryTodaySearchCount: 0, //今日搜索量 工厂
                brandTodaySearchCount: 0, //今日搜索量 品牌
                // 临时保存正在编辑的行ID和值
                // 排序编辑专用变量
                // 临时保存正在编辑的行ID和值
                editingKey: null,
                editingValue: null,
                factoryList: [],
                brandList: [],
                editRules: {
                    searchCategory: [{required: true, message: '请选择搜索分类'}],
                    keyword: [{required: true, message: '请输入搜索关键词'}],
                },
            };
        },
        created() {
        },
        activated() {
        },
        mounted() {
            const storedQuery = localStorage.getItem('searchManage_searchQuery');
            if (storedQuery) {
                this.filterData = JSON.parse(storedQuery);
            } else {
            }
            this.getData(1);
            this.getFactory()
            this.getBrand()
        },
        beforeRouteLeave(to, from, next) {
            localStorage.setItem('searchManage_searchQuery', JSON.stringify(this.filterData));
            next();
        },
        methods: {
            getFactory() {
                getBusinessEntitiesApi({
                    pageNo: 1,
                    pageSize: 9999,
                    businessType: "FACTORY",
                    businessStatus: true,
                    factoryStatus:true,
                    lang:this.filterData.lang

                })
                    .then((res) => {
                        if (res.resultStatus) {
                            this.factoryList = res.resultData.dataList || [];
                        } else {
                            this.factoryList = [];
                        }
                    })
            },
            getBrand() {
                getBusinessEntitiesApi({
                    pageNo: 1,
                    pageSize: 9999,
                    businessType: "BRABD",
                    businessStatus: true,
                    factoryStatus:true,
                    lang:this.filterData.lang
                })
                    .then((res) => {
                        if (res.resultStatus) {
                            this.brandList = res.resultData.dataList || [];
                        } else {
                            this.brandList = [];
                        }
                    })
            },
            toAdd() {
                this.editModel = {
                    flag: true,
                    title: "添加搜索词",
                    "hotwordId": 0, //ID
                    "searchCategory": this.filterData.searchCategory || 'FACTORY', //标签类型
                    "keyword": null, //标签分类 中文
                    "searchCount": 0, //标签分类 英文
                    "status": undefined,
                    "sort": null, //标签分类 英文
                    // "associatedId": undefined,
                    factoryAssociatedId: undefined,
                    brandAssociatedId: undefined,
                    onOk: this.sureEdit,
                };
                console.log(this.editModel)
                this.$nextTick(() => {
                    this.$refs.editForm && this.$refs.editForm.clearValidate();
                });
            },
            sureEdit() {
                if (!this.$refs.editForm) return;
                this.$refs.editForm.validate((valid) => {
                    if (!valid) return;
                    let associatedId;
                    if (this.editModel.searchCategory === 'FACTORY') {
                        associatedId = this.editModel.factoryAssociatedId;
                    } else if (this.editModel.searchCategory === 'BRAND') {
                        associatedId = this.editModel.brandAssociatedId;
                    }
                    saveHotWordsApi({
                        hotwordId: this.editModel.hotwordId ?? 0,
                        "searchCategory": this.editModel.searchCategory, //搜索分类：FACTORY-工厂 BRAND-品牌
                        "keyword": this.editModel.keyword, //关键词
                        "status": this.editModel.status, //发布状态
                        "sort": this.editModel.sort, //排序
                        "associatedId": associatedId //工厂、品牌  businessId
                    }).then((res) => {
                        if (res.resultStatus) {
                            this.$message.success(this.editModel.hotwordId ? "编辑成功" : "新增成功");
                            this.getData(this.pageInfo.current);
                            this.editModel.flag = false
                        } else {
                            this.$message.error(res.errorMessage || '操作失败');
                        }
                    }).catch((error) => {
                        console.log(error);
                    });
                });
            },
            changeTabTop() {
                this.pageInfo.current = 1;
                this.getData(1);
                this.getFactory()
                this.getBrand()
            },
            changeTab() {
                this.pageInfo.current = 1;
                this.getData(1);
            },
            statusChange($event) {
                this.editModel.status = !this.editModel.status
            },
            // 【上架状态】：启用时：按钮点亮状态，单击切换为禁用时，系统提示“切换为禁用状态，则当前数据禁用，系统内不可选？”确认/取消；
            // 禁用时：按钮置灰状态，单击切换为启用状态时，系统提示“已切换为启用状态”。停留2秒消失
            handlePublishChange(checked, record) {
                const content = checked ?
                    '切换为启用状态，则当前数据用户前端可查看，确认变更当前数据状态？' :
                    '切换为禁用状态，则当前数据前端不可查看，确认变更当前数据状态？';
                this.$confirm({
                    title: '操作确认',
                    content,
                    okText: '确定',
                    cancelText: '取消',
                    onOk: () => {
                        updateHotWordsStatusApi({
                            hotwordId: record.hotwordId,
                        }).then(res => {
                            if (res.resultStatus) {
                                this.$message.success("修改成功");
                                this.getData(this.pageInfo.current);
                            } else {
                                this.$message.error(res.errorMessage || '操作失败');
                            }
                        }).catch(err => console.error(err));
                    }
                });
            },

            handleSaveSort(record) {
                if (record.sort === undefined || record.sort === null || record.sort === '') return
                updateHotWordsSortApi({
                    hotwordId: record.hotwordId,
                    sort: record.sort
                }).then(res => {
                    if (res.resultStatus) {
                        this.$message.success('排序保存成功')
                        this.getData(this.pageInfo.current)
                    } else {
                        this.$message.error('保存失败')
                    }
                }).catch(() => this.$message.error('保存失败'))
            },


            // 进入编辑状态
            handleEditSort(record) {
                this.editingKey = record.hotwordId;
                this.editingValue = record.sort;
            },

            // 取消编辑
            handleCancelEdit() {
                this.editingKey = null;
                this.editingValue = null;
            },


            changeStatus(record, value) {
                updateHotWordsStatusApi({
                    "hotwordId": record.hotwordId
                })
                    .then((res) => {
                        if (res.resultStatus) {
                            this.$message.success(
                                value == '1' ? "状态更新成功" : "已切换为启用状态"
                            );
                        } else {
                            this.$message.error(res.errorMessage || '操作失败');
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.getData(this.pageInfo.current)
                    })
            },

            onTabChange(key) {
                console.log('Tab changed to:', key);
                this.activeTab = key;
                this.getData(1);
            },
            handleCategoryChange() {
                this.pageInfo.current = 1;
                this.loadTableData();
            },
            handleBlur() {
                console.log('blur');
            },
            handleFocus() {
                console.log('focus');
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            changePage(page) {
                this.pageInfo.current = page.current;
                this.getData(this.pageInfo.current);
            },
            toSearch(flag) {
                if (flag) {
                    this.getData(1);
                } else {
                    this.filterData.keywords = "";
                    this.filterData.status = undefined
                    this.getData(1);
                }
            },
            getData(page = 1) {
                this.pageInfo.current = page;
                if (this.loading) {
                    return;
                }
                this.loading = true;
                getHotWordsListApi({
                    pageNo: this.pageInfo.current,
                    pageSize: this.pageInfo.pageSize,
                    keywords: this.filterData.keywords,
                    lang: this.filterData.lang,
                    status: this.filterData.status,
                    searchCategory: this.filterData.searchCategory
                })
                    .then((res) => {
                        if (res.resultStatus) {
                            this.tableData = res.resultData.dataList || [];
                            this.pageInfo.total = res.resultData.totalNum || 0;
                            this.factoryNum = res.resultData.factoryNum || 0;
                            this.brandNum = res.resultData.brandNum || 0;
                            this.factoryEnableNum = res.resultData.factoryEnableNum || 0;
                            this.brandEnableNum = res.resultData.brandEnableNum || 0;
                            this.factoryTodaySearchCount = res.resultData.factoryTodaySearchCount || 0;
                            this.brandTodaySearchCount = res.resultData.brandTodaySearchCount || 0;
                        } else {
                            this.tableData = [];
                            this.pageInfo.total = 0;
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            clearAssociatedIds() {
                // 切换分类清空两个选中值
                this.editModel.factoryAssociatedId = undefined;
                this.editModel.brandAssociatedId = undefined;
                // 清除表单校验提示
                this.$nextTick(() => {
                    this.$refs.editForm.clearValidate(['factoryAssociatedId', 'brandAssociatedId'])
                })
            },
            toEdit(data) {
                getHotWordsDetailApi({
                    hotwordId: data.hotwordId,
                })
                    .then((res) => {
                        if (res.resultStatus) {
                            const result = res.resultData;
                            // 先清空
                            let facId = undefined;
                            let braId = undefined;
                            if (result.searchCategory == 'FACTORY') {
                                facId = result.associatedId;
                            } else if (result.searchCategory == 'BRAND') {
                                braId = result.associatedId;
                            }
                            this.editModel = {
                                "flag": true,
                                "title": "修改搜索词",
                                "hotwordId": result.hotwordId, //ID
                                "searchCategory": result.searchCategory, //标签类型
                                "keyword": result.keyword, //标签分类 中文
                                "searchCount": result.searchCount, //标签分类 英文
                                "status": result.status,
                                "sort": result.sort, //标签分类 英文
                                // "associatedId": result.associatedId,
                                "factoryAssociatedId": facId,
                                "brandAssociatedId": braId,
                                "lang": result.lang,
                                "id": result.id,
                                onOk: this.sureEdit,
                            };
                            this.$nextTick(() => {
                                this.$refs.editForm && this.$refs.editForm.clearValidate();
                            });
                        } else {
                            console.log("res");
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            },
            confirm() {

            },
            toSeeImg(data) {
                this.imgModel = {
                    flag: true,
                    url: data.iconUrl,
                };
            },
            sureDelete(record) {
                deleteHotWordsApi({
                    hotwordId: record.hotwordId,
                }).then((res) => {
                    if (res.resultStatus) this.$message.success("删除成功");
                }).catch((error) => {
                    console.log(error);
                }).finally(() => {
                    this.getData(this.pageInfo.current);
                });
            },
            // 上传文件
            // handleUpdataFile(e) {
            // 	if (e.target.files.length) {
            // 		const file = e.target.files[0];
            // 		console.log("file", file);
            // 		if (file) {
            // 			const form = new FormData();
            // 			form.append("file", file);
            // 			console.log("form", form);
            // 			getOssAuth(form).then((res) => {
            // 				if (res.resultStatus) {
            // 					this.editModel.iconUrl = res.resultData.fileLink;
            // 				}
            // 			});
            // 		}
            // 	}
            // },
        },
    };
</script>

<style lang="less">
    .container_page {
        padding: 20px;
        background: #ffffff;

        .filter_box {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 12px;
        }

        .mr12 {
            margin-right: 12px;
        }

        .stat-card {
            width: 100%;
            height: 160px;
            background: #ECFFF7;
            padding: 20px 20px 0;
            border-radius: 10px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }

        /* 头部布局 */

        .stat-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .stat-bot {

            .t1 {
                width: 50%;
                height: 30px;
                color: #333;
            }

            .t2 {
                color: #333;
                width: 50%;
                height: 30px;
            }
        }

        /* 文字1 18px */

        .stat-t1 {
            font-size: 18px;
            display: block;
            color: #333;
            /* 让文字上下排列 */
        }

        /* 文字2 32px */

        .stat-t2 {
            font-size: 32px;
            font-weight: bold;
            color: #333;
            /* 数字一般加粗更好看 */
            display: block;
        }
    }

    .lang-radio-wrap {
        display: flex;
        justify-content: center;
        margin-bottom: 16px;
    }
</style>
